import React from 'react';
import { Checkbox, RadioDial } from '@noths/polaris-client-ribbons-design-system';
import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { ProductOptionValue } from 'src/types';
import { getFormattedPersonalisationAmount } from 'src/utils';
import * as styles from '../../styles/SelectionOptionValue.styles';

interface SelectedOptionValueLabelProps {
  currency: CurrencyCode;
  error: boolean;
  value: ProductOptionValue;
  isSelected: boolean;
  name: string;
  inputType: 'checkbox' | 'radio';
  onChange: (value: ProductOptionValue | null) => void;
  onFocus?: () => void;
}

const getId = (id: number) => `${id}__input`;

const NO_OP = () => {};

export const SelectedOptionValueLabel = ({
  currency,
  value,
  isSelected,
  inputType,
  name,
  error,
  onChange,
  onFocus,
}: SelectedOptionValueLabelProps) => {
  const { isNegative = false, value: formattedPriceValue = '' } = value.priceModifier
    ? getFormattedPersonalisationAmount(currency, value.priceModifier)
    : {};

  const handleOnRadioClick = () => {
    const newValue = isSelected ? null : value;

    onChange(newValue);
  };

  const id = getId(value.id);

  return (
    <div css={styles.wrapper} data-is-selected={isSelected}>
      {inputType === 'checkbox' ? (
        <Checkbox
          id={id}
          name={name}
          checked={isSelected}
          onChange={() => onChange(value)}
          onFocus={onFocus}
          {...{ 'aria-invalid': error }}
        />
      ) : (
        <RadioDial
          id={id}
          name={name}
          checked={isSelected}
          onChange={NO_OP}
          onClick={handleOnRadioClick}
          css={styles.radioDial}
          onFocus={onFocus}
          {...{ 'aria-invalid': error }}
        />
      )}
      <label css={styles.label} htmlFor={id}>
        <span dangerouslySetInnerHTML={{ __html: value.name }} />
        {value.priceModifier && (
          <span css={styles.priceModifier}>
            <span data-is-negative={isNegative} css={styles.priceOperator}>
              {isNegative ? <>&minus;</> : <>&#43;</>}
            </span>
            <span>{formattedPriceValue.replace('-', '')}</span>
          </span>
        )}
      </label>
    </div>
  );
};
